import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumb from "@/components/Breadcrumb";
import CtaBand from "@/components/CtaBand";
import { ARTICLES } from "@/data/articles";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const Guides = () => (
  <>
    <Seo
      title="Guides fibre optique & sous-traitance FTTH | ATLAS THD"
      description="Guides métier ATLAS THD : choisir un sous-traitant fibre optique, étapes d'un raccordement FTTH D3, externalisation des travaux FTTH."
      breadcrumbs={[{ label: "Accueil", to: "/" }, { label: "Guides" }]}
    />

    <section className="border-b border-line bg-cloud" data-testid="guides-hero">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:py-20 lg:px-8">
        <Breadcrumb items={[{ label: "Accueil", to: "/" }, { label: "Guides" }]} />
        <motion.p {...fadeUp} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="mt-6 font-display text-xs font-bold uppercase tracking-[0.25em] text-steel">
          Guides & expertise métier
        </motion.p>
        <motion.h1 {...fadeUp} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.15 }} className="mt-4 max-w-4xl font-display text-4xl font-extrabold tracking-tight text-midnight sm:text-5xl">
          Guides fibre optique et sous-traitance FTTH
        </motion.h1>
        <motion.p {...fadeUp} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.3 }} className="mt-6 max-w-3xl text-lg leading-relaxed text-steel">
          Des contenus écrits par des professionnels du terrain, pour les
          responsables d'exploitation, conducteurs de travaux et responsables
          achats qui pilotent des travaux fibre optique.
        </motion.p>
      </div>
    </section>

    <section className="bg-white py-16 lg:py-20" data-testid="guides-list">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-px border border-line bg-line md:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <motion.div key={a.slug} {...fadeUp} transition={{ duration: 0.4, delay: i * 0.08 }} data-testid={`guide-card-${i}`}>
              <Link to={`/guides/${a.slug}`} className="group flex h-full flex-col bg-white p-8 transition-colors hover:bg-cloud lg:p-10">
                <BookOpen className="h-7 w-7 text-terrain" />
                <h2 className="mt-6 font-display text-xl font-bold leading-snug tracking-tight text-midnight">
                  {a.title}
                </h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-steel">{a.description}</p>
                <span className="mt-6 inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-terrain transition-colors group-hover:text-midnight">
                  Lire le guide
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    <CtaBand title="Une question sur votre projet fibre optique ?" />
  </>
);

export default Guides;
